import type { ChangeEvent } from 'react';
import type { SxProps } from '@mui/material';
import TextField from '@mui/material/TextField';

export function isValidIsoDate(s: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
  const [y, m, d] = s.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d;
}

function formatDigitsInput(raw: string): string {
  let input = raw.replace(/\D/g, '').slice(0, 8);
  if (input.length > 4) {
    input = `${input.slice(0, 4)}-${input.slice(4)}`;
  }
  if (input.length > 7) {
    input = `${input.slice(0, 7)}-${input.slice(7)}`;
  }
  return input;
}

type IsoDateTextFieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: (formatted: string) => void;
  onBlur?: () => void;
  sx?: SxProps;
  'aria-label'?: string;
};

export function IsoDateTextField({
  id,
  label,
  value,
  onChange,
  onBlur,
  sx,
  'aria-label': ariaLabel,
}: IsoDateTextFieldProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(formatDigitsInput(e.target.value));
  };

  return (
    <TextField
      id={id}
      label={label}
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      placeholder="YYYY-MM-DD"
      variant="standard"
      size="small"
      fullWidth
      sx={sx}
      InputLabelProps={{ shrink: true }}
      slotProps={{
        htmlInput: {
          inputMode: 'numeric',
          maxLength: 10,
          'aria-label': ariaLabel ?? label,
        },
      }}
    />
  );
}